/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Webvtt_VttInputs */



/**
* | output |
* | --- |
* | "WebVtt (.vtt)" |
*
* @param {Webvtt_VttInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const webvtt_vtt = /** @type {((inputs?: Webvtt_VttInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Webvtt_VttInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("WebVtt (.vtt)")
	if (locale === "de") return /** @type {LocalizedString} */ ("WebVtt (.vtt)")
	if (locale === "it") return /** @type {LocalizedString} */ ("WebVtt (.vtt)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("WebVtt (.vtt)")
	if (locale === "es") return /** @type {LocalizedString} */ ("WebVtt (.vtt)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("WebVtt (.vtt)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("WebVtt (.vtt)")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वेबवीटीटी (.vtt)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("WebVtt (.vtt)")
	return /** @type {LocalizedString} */ ("WebVtt (.vtt)")
});